import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { faGlobe } from '@fortawesome/pro-solid-svg-icons';
import { Tag as TagAtom } from '@rocketlane/ui';
import { PageTemplateSectionSource } from 'api/custom-section/types';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { css } from 'styled-components';

const Tag = styled(TagAtom)`
  ${({ onClick }) =>
    onClick &&
    css`
      cursor: pointer;
    `};
`;

interface Props {
  sources: PageTemplateSectionSource[];
  onClick?: () => void;
  className?: string;
}
export const CompanyPageDerivedSectionSources: FC<Props> = ({
  sources,
  onClick,
  className,
}) => {
  return (
    <Tag
      color="blue"
      variant="basic"
      icon={
        <FontAwesomeIcon
          icon={faGlobe}
          size={16}
          iconSize={12}
          color={'transparent'}
        />
      }
      onClick={onClick}
      className={className}
    >
      <FormattedMessage
        id="rich_text_editor.sections.company_page_source_derived_section.sources_tag.label"
        values={{
          count: sources.length,
        }}
      />
    </Tag>
  );
};
